import { useState, useCallback } from 'react';
import { addDays } from 'date-fns';
import useApiFetch from '@/hooks/useApiFetch';
import chartsServices from '@/services/charts';
import { FetchApiIds } from '@/types';
import { defaultChartPeriod, today } from '@/utils/chart';
import RejectedChartComponent from './RejectedChart.component';

const RejectedChartContainer = function (): JSX.Element {
  const [selectedFilter, setSelectedFilter] = useState(today);
  const periodOptions = defaultChartPeriod(selectedFilter);

  const onSelectFilter = useCallback((value: string): void => {
    setSelectedFilter(value);
  }, []);

  const rejectByClientStatuses = ['FAILED_CLIENT_VALIDATION', 'FAILED_TEAM_INTERVIEW'];
  const rejectByTrioStatuses = [
    'LOW_LEVEL_ENGLISH',
    'HIGH_SALARY',
    'FAILED_SCREENING',
    'READY_TO_HIRE',
    'FAILED_TAKE_HOME_REVIEW',
  ];
  const allStatuses = [...rejectByTrioStatuses, ...rejectByClientStatuses];

  const labels = [
    { label: 'by Partners', color: '#EF5B5B' },
    { label: 'by Trio', color: '#FF991C' },
  ];

  const candidatesFilteredResponsse = useApiFetch(
    [FetchApiIds.REJECTED_CHART, selectedFilter],
    async () => {
      const updatedHour = new Date(selectedFilter);
      const updatedTo = addDays(new Date(today), 1);
      updatedHour.setHours(0, 0, 0, 0);
      return chartsServices.getByStatusAndPeriod({
        status: allStatuses.toString().toUpperCase(),
        startDate: updatedHour.toISOString(),
        endDate: updatedTo.toISOString(),
      });
    }
  );

  const formattedValuee = labels.map(({ label }) => {
    const candidatesByStatus = candidatesFilteredResponsse.data ?? {};
    const isByTrio = label.includes('Trio');
    const arraysToCompare = isByTrio ? rejectByTrioStatuses : rejectByClientStatuses;
    const totalOfCandidates = arraysToCompare.reduce((acc, cur) => {
      return acc + (candidatesByStatus[cur] || 0);
    }, 0);

    return {
      value: totalOfCandidates,
      name: `${totalOfCandidates} ${label}`,
    };
  });

  const totalOfCandidates = formattedValuee.reduce((acc, cur) => {
    return acc + cur?.value;
  }, 0);

  return (
    <RejectedChartComponent
      onSelectFilter={onSelectFilter}
      periodOptions={periodOptions}
      isLoading={candidatesFilteredResponsse.isLoading}
      title="Rejected"
      data={formattedValuee}
      total={totalOfCandidates}
      colors={labels.map((label) => label.color)}
    />
  );
};

export default RejectedChartContainer;
